import { Checkbox } from 'baseui/checkbox';
import { TreeLabelInteractable } from 'baseui/tree-view';

type Props = Readonly<{
  label: string;
  value: boolean;
  setValue: (val: boolean) => void;
  isIndeterminate: boolean;
  disabled: boolean;
}>;

export function PermissionTreeItem({ label, value, setValue, isIndeterminate, disabled }: Props) {
  return (
    <TreeLabelInteractable
      overrides={{
        LabelInteractable: {
          component: () => (
            <Checkbox
              disabled={disabled}
              isIndeterminate={isIndeterminate}
              checked={value}
              overrides={{
                Root: {
                  props: {
                    onClick: (event: Event) => {
                      event.stopPropagation();
                      setValue(!value);
                    },
                  },
                },
                Checkmark: {
                  style: ({ $disabled, $checked, $theme, $isIndeterminate }) => {
                    if ($disabled) {
                      return {
                        backgroundColor:
                          $checked || $isIndeterminate ? $theme.colors.gray700Dark : $theme.colors.backgroundPrimary,
                        borderLeftColor: $theme.colors.gray700Dark,
                        borderRightColor: $theme.colors.gray700Dark,
                        borderTopColor: $theme.colors.gray700Dark,
                        borderBottomColor: $theme.colors.gray700Dark,
                      };
                    }
                  },
                },
              }}
            >
              {label}
            </Checkbox>
          ),
        },
      }}
    />
  );
}
